'use client';

import { SmartIcon } from '@/shared/blocks/common/smart-icon';
import { ScrollAnimation } from '@/shared/components/ui/scroll-animation';
import { cn } from '@/shared/lib/utils';
import { Section } from '@/shared/types/blocks/landing';

export function FeaturesStep({
  section,
  className,
}: {
  section: Section;
  className?: string;
}) {
  return (
    <section
      id={section.id}
      className={cn('section-warm py-16 md:py-24', section.className, className)}
    >
      <div className="container">
        {/* Section Header */}
        <ScrollAnimation>
          <div className="section-header mb-16 max-w-[600px]">
            {section.label && (
              <p className="section-label">{section.label}</p>
            )}
            <h2 className="section-title text-foreground">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-lg font-light text-muted-foreground">
                {section.description}
              </p>
            )}
          </div>
        </ScrollAnimation>

        {/* Steps Grid - Demo Style */}
        <ScrollAnimation delay={0.2}>
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {section.items?.map((item, idx) => (
              <div 
                className="relative pt-8" 
                key={idx}
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                {/* Top border gradient */}
                <div 
                  className="absolute left-0 right-0 top-0 h-px"
                  style={{ background: 'linear-gradient(90deg, var(--thread-gold), transparent)' }}
                />
                
                {/* Step Number - Outline Style */}
                <div className="step-number-outline mb-6">
                  {String(idx + 1).padStart(2, '0')}
                </div>
                
                {/* Step Title */}
                <h3 className="mb-3 font-display text-lg font-semibold tracking-wide text-foreground">
                  {item.title}
                </h3>
                
                {/* Step Description */}
                <p className="text-sm font-light leading-relaxed text-muted-foreground">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
